import React from 'react';
import { Link } from 'react-router-dom';
import styles from './QuickServicesCard.module.scss';
import { LockIconFilled } from '../../../../../assets/icons';

interface QuickServiceCardProps {
  icon: React.ReactNode;
  title: string;
  link?: string;
  isLocked?: boolean;
  onClick?: () => void;
}

const QuickServiceCard: React.FC<QuickServiceCardProps> = ({
  icon,
  title,
  link,
  isLocked = false,
  onClick,
}) => {
  const inner = (
    <>
      {isLocked &&
      <div className={styles.lockDot}>
        <LockIconFilled className={styles.lockIcon} />
      </div> 
      }
      <div className={styles.iconCircle}>{icon}</div>
      <span className={styles.title}>{title}</span>
    </>
  );

  if (link && !isLocked) {
    return (
      <Link to={link} className={styles.card} >
        {inner}
      </Link>
    );
  }

  // A locked tile with an onClick stays actionable (e.g. diverting to energy
  // profile setup); a locked tile without one is disabled (e.g. "New Service").
  return (
    <button
      type="button"
      className={`${styles.card} ${isLocked ? styles.locked : ''}`}
      onClick={onClick}
      disabled={isLocked && !onClick}
    >
      {inner}
    </button>
  );
};

export default QuickServiceCard;
